var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"btn btn-light border-muted",attrs:{"to":_vm.to,"title":_vm.label}},[_c('IconPlus',{staticClass:"fill-color",attrs:{"width":"1em","height":"1em","viewBox":"0 0 16 16","aria-hidden":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }